/**
 * @file: WiredImagePreview.tsx
 *
 * State wrapper for the shared {@link ImageViewer}: subscribes the room's
 * image-preview state (all conversation images + the tapped index, set when
 * an image bubble is tapped) and shows the full-screen swipeable viewer.
 */

import { ImageViewer } from '@euler/app/components/media/ImageViewer';
import { useChatConversation } from '@euler/app/flows/chat/lib/conversation/context';
import { useBehaviorSubject } from '@euler/utils/hooks';
import { FC, memo } from 'react';

export const WiredImagePreview: FC = memo(() => {
  const { imagePreview } = useChatConversation().coordinator;
  const [preview] = useBehaviorSubject(imagePreview.state$);
  return (
    <ImageViewer
      images={preview?.images ?? []}
      index={preview?.index ?? 0}
      show={!!preview}
      onDismiss={imagePreview.close}
    />
  );
});
